import { render, staticRenderFns } from "./OnboardingIntroLink.vue?vue&type=template&id=5c02e56e&"
import script from "./OnboardingIntroLink.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntroLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports